import React from 'react';
import { ContentContainer, Title, TitleContainer, CloseContainer, Column, ButtonNo, ButtonYes } from './ModalConfirm.styles';

import { ReactComponent as Close } from '../../assets/icons/close.svg';
import { ReactComponent as Loader } from '../../assets/icons/loader-white.svg';

import { useTranslation } from 'react-i18next';
import Modal2 from '../utils/Modal2';

const ModalConfirm = ({ onClickYes, onClickNo, title, confirmLoading, open, close }) => {
  const { t } = useTranslation();

  return (
    <Modal2
      border={'2px solid #484888'}
      bg={'linear-gradient(360deg, #7f7fac -100%, #484888 100%)'}
      onClose={close}
      open={open}
      height={'fit-content'}
      width={'fit-content'}>
      <ContentContainer>
        <CloseContainer onClick={close}>
          <Close className="close" fill="#fff" />
        </CloseContainer>

        <Column>
          <TitleContainer>{!title ? <Title>{t('are-you-sure')}</Title> : <Title>{t(`${title}`)}</Title>}</TitleContainer>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 20 }}>
            <ButtonYes
              loading={confirmLoading}
              style={{ padding: '10px 24px' }}
              onClick={() => {
                if (!confirmLoading) {
                  onClickYes();
                }
              }}>
              {confirmLoading ? <Loader height={24} /> : t(`${'yes'}`)}
            </ButtonYes>
            {!confirmLoading && (
              <ButtonNo style={{ padding: '10px 24px' }} onClick={onClickNo}>
                {t('no')}
              </ButtonNo>
            )}
          </div>
        </Column>
      </ContentContainer>
    </Modal2>
  );
};

export default ModalConfirm;
